module.exports = __webpack_public_path__ + "img/9788963714226.2667db8d.jpg";